module.exports = __webpack_public_path__ + "img/upload-icon.ea39bf99.svg";